import React from 'react';
import { Check } from 'lucide-react';

interface Step {
  number: number;
  name: string;
}

interface WizardStepsProps {
  steps: Step[];
  currentStep: number;
  onStepClick?: (step: number) => void;
}

export const WizardSteps: React.FC<WizardStepsProps> = ({ steps, currentStep, onStepClick }) => {
  return (
    <div className="flex items-center justify-between">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className="flex flex-col items-center">
            <div
              onClick={() => onStepClick && onStepClick(step.number)}
              className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold transition-all ${
                step.number < currentStep
                  ? 'bg-green-500 text-white'
                  : step.number === currentStep
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400'
              } ${onStepClick ? 'cursor-pointer hover:opacity-80' : ''}`}
            >
              {step.number < currentStep ? (
                <Check className="w-5 h-5" />
              ) : (
                step.number
              )}
            </div>
            <span
              className={`text-sm mt-2 text-center ${
                step.number === currentStep
                  ? 'font-semibold text-green-600 dark:text-green-400'
                  : 'text-gray-600 dark:text-gray-400'
              }`}
            >
              {step.name}
            </span>
          </div>

          {index < steps.length - 1 && (
            <div className="flex-1 h-1 mx-2 mb-6">
              <div
                className={`h-full transition-all ${
                  step.number < currentStep ? 'bg-green-500' : 'bg-gray-200 dark:bg-gray-700'
                }`}
              />
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
